import { ProcessingStatus } from '@/types/Document';

interface ProcessingStatusBadgeProps {
  status: ProcessingStatus | undefined;
}

// Function to get status badge style
const getStatusBadgeStyle = (status: ProcessingStatus | undefined): string => {
  if (!status || status === 'not_processed') return 'bg-gray-100 text-gray-800 border-gray-300';
  
  switch (status) {
    case 'done':
      return 'bg-green-100 text-green-800 border-green-300';
    case 'queued':
    case 'processing':
    case 'uploading':
    case 'preparing':
    case 'in_progress':
      return 'bg-blue-100 text-blue-800 border-blue-300';
    case 'error':
      return 'bg-red-100 text-red-800 border-red-300';
    default:
      return 'bg-gray-100 text-gray-800 border-gray-300';
  }
};

// Function to format status text
const formatStatusText = (status: ProcessingStatus | undefined): string => {
  if (!status) return 'Not Processed';
  
  switch (status) {
    case 'not_processed':
      return 'Not Processed';
    case 'done':
      return 'Processed';
    case 'queued':
      return 'In Queue';
    case 'processing':
      return 'Processing';
    case 'uploading':
      return 'Uploading';
    case 'preparing':
      return 'Preparing';
    case 'in_progress':
      return 'In Progress';
    case 'error':
      return 'Failed';
    default:
      return 'Unknown Status';
  }
};

export default function ProcessingStatusBadge({ status }: ProcessingStatusBadgeProps) {
  return (
    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full border ${getStatusBadgeStyle(status)}`}>
      {formatStatusText(status)}
    </span>
  );
}

// Export utility functions for use elsewhere if needed
export { getStatusBadgeStyle, formatStatusText };
